<template>
    <section
        v-if="!isPreview && !loading && keepWatchingVideo.id"
        class="section-keep-watching"
    >
        <div class="section-keep-watching__inner">
            <h2 class="section-keep-watching__title">{{ $t('student.dashboard.keepWatching') }}</h2>
            <KeepWatchingCard
                :id="keepWatchingVideo.id"
                :image="keepWatchingVideo.image"
                :title="keepWatchingVideo.title"
                :description="keepWatchingVideo.description"
            />
        </div>
    </section>
</template>

<script>
    import KeepWatchingCard from './KeepWatchingCard.vue';
    import lessonApi  from '@/utils/portal/lesson';
    import { moduleTokenFromEnrol } from '@/utils/portal/courseToken';
    import Loader from '@/components/Loader/loader.vue';
    import { mapState, mapActions } from 'vuex';
    

    export default {
        name: 'KeepWatchingSection',
        components: {
            KeepWatchingCard,
            Loader,
        },
        computed: {
            ...mapState(['token', 'user', 'previewAs']),
            isPreview() {
                return Boolean(this.previewAs?.enabled && this.previewAs.sectorId);
            },
        },
        data() {
            return {
                keepWatchingVideo: {
                    id: '',
                    image: '',
                    title: '',
                    description: '',
                },
                loading: true,
            };
        },
        created() {
            if (this.isPreview) {
                this.loading = false;
                return;
            }
            this.getLatestCourse();
        },
        methods: {
            ...mapActions(['storeLatestCourse','storeCurrentCoursePortal']),
            async getLatestCourse() {
                this.loading = true;
                try {
                    const response = await lessonApi.getLatestCourse(this.token);
                    const token = moduleTokenFromEnrol(response, this.user?.type);
                    if (!token || !response?.course) return;
                    this.storeLatestCourse({ latestCourse: response });
                    this.storeCurrentCoursePortal({ currentCoursePortal: response });
                    this.keepWatchingVideo.id = token;
                    this.keepWatchingVideo.image = response.course.imageFinalPath
                        || response.course.imageFinalPath2
                        || '';
                    this.keepWatchingVideo.title = response.course.name;
                    this.keepWatchingVideo.description = response.course.shortDescription;
                } catch (error) {
                    console.error('Erro ao carregar último curso local:', error);
                } finally {
                    this.loading = false;
                }
            }
        }
    };
</script>

<style scoped>
    .section-keep-watching {
        padding: 20px 0 8px;
        position: relative;
        background-color: transparent;
    }

    .section-keep-watching__inner {
        max-width: 1600px;
        margin: 0 auto;
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px;
    }

    .section-keep-watching__title {
        font-size: 1.25rem;
        font-weight: 700;
        margin: 0 0 14px;
        color: #1F2937;
        text-align: left;
        letter-spacing: -0.02em;
    }

    .dark .section-keep-watching__title {
        color: #f2f4f8;
    }

    @media (max-width: 959px) {
        .section-keep-watching {
            padding: 16px 0 4px;
        }

        .section-keep-watching__inner {
            padding: 0;
        }

        .section-keep-watching__title {
            font-size: 1.125rem;
            margin-bottom: 12px;
        }
    }
</style>
